import * as React from 'react';
import { clsx } from 'clsx';
import { Button } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SelectButton.css';

export interface ISelectButtonProps {
  text?: string;
  open?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
  onToggle(): void;
  maxWidth?: number;
  dataTestId?: string;
}

export function SelectButton({
  text,
  open,
  ref,
  onToggle,
  maxWidth,
  dataTestId,
}: ISelectButtonProps): React.JSX.Element {
  return (
    <Button
      ref={ref}
      onClick={onToggle}
      size="M"
      tabIndex={-1}
      theme="stroke_secondary"
      type="button"
      fullWidth
      maxWidth={maxWidth}
      data-testid={dataTestId}
      afterIcon={
        <span className={clsx(styles['arrow_icon'], open && styles['arrow_icon__open'])} aria-hidden>
          <IconActionChevronRightSmall16 color="current_color" />
        </span>
      }
    >
      {text}
    </Button>
  );
}
